export default __webpack_public_path__ + "static/media/ic-sent-coin.ea796dc9.svg";